import React, { useMemo } from "react";
import { AgencyContext } from "./AgencyContext";
import { AgencyState } from "./AgencyState";

export const AgencyContextProvider = ({ children }: { children: any }) => {
  const value = useMemo(() => new AgencyState(), []);

  return (
    <AgencyContext.Provider value={value}>{children}</AgencyContext.Provider>
  );
};
